import React from "react";

// DateBid brand marks (transparent PNG-sourced WebP, originals preserved in /public/brand).
// wordmark = crowned-heart DateBid wordmark (DB1) for nav/footer/auth.
// hero     = elaborate winged crowned-heart (DB2) for the homepage hero.
const SRC = {
  wordmark: "/brand/db-logo-wordmark.webp",
  wordmarkSm: "/brand/db-logo-wordmark-sm.webp",
  hero: "/brand/db-logo-hero.webp",
  heroLg: "/brand/db-logo-hero-lg.webp",
};

export const BrandLogo = ({ variant = "wordmark", className = "", alt = "DateBid", ...rest }) => (
  <img
    src={SRC[variant] || SRC.wordmark}
    alt={alt}
    draggable={false}
    loading={variant.startsWith("hero") ? "eager" : "lazy"}
    className={className}
    {...rest}
  />
);

export default BrandLogo;
